<template>
  <span>
    <v-card class="elevation-10">
      <payment-slips-header
        :payment_slips="paymentSlips"
        :amount="cards"
        :activeStatus="status"
        @activeStatusChanged="changeActiveStatus"
      />
    </v-card>

    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="teal darken-4"
    />

    <payment-slips-list
      :payment_slips="paymentSlips"
      :activeStatus="status"
      :totalPages="total_pages"
      :totalItems="cards.total"
      @changePage="changePage"
    />
  </span>
</template>

<script>
import PaymentSlipsService from '@/services/applications/PaymentSlipsService';
import PaymentSlipsList from '@/components/tabs/list/PaymentSlipsList';
import PaymentSlipsHeader from '@/components/tabs/header/PaymentSlipsHeader';

export default {
  name: 'PaymentSlips',
  props: ['isAdmin'],
  components: {
    PaymentSlipsList,
    PaymentSlipsHeader,
  },
  data() {
    return {
      status: '',
      page: 1,
      paymentSlips: [],
      cards: { total: 0 },
      total_filtered: 0,
      total_pages: 0,
      isLoading: false,
    };
  },
  mounted() {
    this.fetchPaymentSlips();
  },
  methods: {
    changeActiveStatus(status) {
      this.status = status;
      this.fetchPaymentSlips();
    },
    fetchPaymentSlips() {
      this.isLoading = true;
      if (this.isAdmin) {
        this.fetchAdminPaymentSlips();
      } else {
        this.fetchUserPaymentSlips();
      }
    },
    fetchUserPaymentSlips() {
      PaymentSlipsService
        .fetchPaymentSlips({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.paymentSlips = data.applications;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
          this.$emit('amount', this.cards.pending);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    fetchAdminPaymentSlips() {
      PaymentSlipsService
        .adminFetchPaymentSlips({ status: this.status, page: this.page })
        .then(({ data }) => {
          this.paymentSlips = data.applications;
          this.cards = data.cards;
          this.total_filtered = data.total_filtered;
          this.total_pages = data.total_pages;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    changePage(page) {
      this.page = page;
      this.fetchPaymentSlips();
    }
  }
}
</script>
